import React, { useEffect, useState } from 'react';
import { futureByInsurer } from '../apis/invoice';
import useStateIfMounted from '../hook/useStateIfMounted';
import Loading from "../common/Loading";
import StatusTable from "./StatusTable";

const InsurerCollection = props => {

    const [data, setData] = useStateIfMounted([]);
    const [loading, setLoading] = useStateIfMounted(true);

    useEffect(() => {
        futureByInsurer().then(result => setData(result.data)).finally(() => setLoading(false));
    }, []);

    return (
        loading ? <Loading className="medium" /> : <StatusTable data={data} datakey="insurer" header="Sigortaci Kirilimi" />
    )

}

export default InsurerCollection;